import React from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import HoverButton from './HoverButton';
import cx from 'classnames';
import { TValue } from 'lib/types/common';

interface IndicationOptionButtonProps {
  children?: React.ReactNode;
  className?: string;
  value: TValue;
  active: boolean;
  onClick: (value: TValue) => void;
}

const IndicationOptionButton = ({
  children,
  className,
  value,
  active,
  onClick,
}: IndicationOptionButtonProps) => {
  return (
    <StyledIndicationOptionButton
      className={cx(`${className}`, { active: active })}
      onClick={() => onClick(value)}
    >
      {children}
    </StyledIndicationOptionButton>
  );
};

const StyledIndicationOptionButton = styled.button<{}>`
  width: 100%;
  min-height: 40px;
  border: 1px solid #e6e6e6;
  &.active {
    border: 2px solid #00a6e2;
  }
`;

export default IndicationOptionButton;
